import React from "react";
import { Link } from "react-router-dom";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomeTreatmentsSection = ({ featured = [] }) => (
    <section
        data-testid={SITE.homeTreatmentsPreview}
        className="sand-wash py-14 sm:py-20 bg-grain"
    >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                <div className="max-w-2xl">
                    <p className="font-accent text-xs text-terracotta">OFFERINGS</p>
                    <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                        Choose your treatment
                    </h2>
                </div>
                <CtaButton to="/treatments" variant="secondary">
                    View all
                </CtaButton>
            </div>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {featured.slice(0, 6).map((t) => (
                    <Link
                        key={t.slug}
                        to="/treatments"
                        className="group rounded-2xl bg-white/85 border border-border/80 overflow-hidden hover:-translate-y-0.5 transition-transform shadow-[0_8px_24px_rgba(30,35,32,0.06)]"
                    >
                        <div className="relative h-44 overflow-hidden bg-sand">
                            <img
                                src={t.image}
                                alt={t.name}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                        </div>
                        <div className="p-5">
                            <p className="text-xs text-foreground/60">{t.duration}</p>
                            <h3 className="mt-1 font-display text-lg text-moss">{t.name}</h3>
                            <p className="mt-1 text-sm text-foreground/70 line-clamp-2">
                                {t.short}
                            </p>
                            <p className="mt-3 text-sm font-medium text-terracotta">{t.price}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export default HomeTreatmentsSection;
